"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyActionFilter = exports.emptyControlFilter = exports.emptyCausalityFilter = exports.emptyRiskFilter = void 0;
exports.emptyRiskFilter = {
    status_choices: [],
    risk_owners: [],
    tags: [],
    confidentiality_groups: [],
    udf_types: [],
    matrices: [],
    risk_reviewers: [],
};
exports.emptyCausalityFilter = __assign(__assign({}, exports.emptyRiskFilter), { causality_status_choices: [] });
exports.emptyControlFilter = __assign(__assign({}, exports.emptyRiskFilter), { control_status_choices: [], control_owners: [], control_tags: [], control_costs: [] });
exports.emptyActionFilter = __assign(__assign({}, exports.emptyControlFilter), { action_status_choices: [], action_owners: [], action_tags: [] });
